import { BASE_URL, isHttps } from '@/api/realApi/_constants';
export function createWS(slug) {
    let ws = null;
    let listeners = [];
    let backoff = 500;
    const token = localStorage.getItem('token');
    const ws_schema = isHttps ? 'wss:' : 'ws:';
    const wsUrl = `${ws_schema}//${BASE_URL}`;
    const url = `${wsUrl}/ws/boards/${slug}/?token=${token !== null && token !== void 0 ? token : ''}`;
    function connect() {
        ws = new WebSocket(url);
        ws.onopen = () => {
            backoff = 500;
        };
        ws.onmessage = (ev) => {
            try {
                const data = JSON.parse(ev.data);
                listeners.forEach((l) => l(data));
            }
            catch (_a) { }
        };
        ws.onclose = () => setTimeout(connect, Math.min((backoff *= 2), 8000));
        ws.onerror = () => {
            try {
                ws === null || ws === void 0 ? void 0 : ws.close();
            }
            catch (_a) { }
        };
    }
    connect();
    function send(msg) {
        if (ws && ws.readyState === ws.OPEN)
            ws.send(JSON.stringify(msg));
    }
    function on(fn) {
        listeners.push(fn);
        return () => {
            listeners = listeners.filter((x) => x !== fn);
        };
    }
    return { send, on };
}
